module.exports = __webpack_public_path__ + "img/thumbnail_Emu_m_leucistic.eb6282e5.png";